module.exports = __webpack_public_path__ + "img/account-icon.e6011a22.svg";